import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Info } from '.';
import { InformationIcon, useStyledTheme } from '../../..';
import { Flex } from '../Flex';

const IconContainer = styled(Flex)`${({ theme }) => `
  width:${theme.padding[6]};
`}`;

export const InfoItemContainer = styled.div`${({ theme }) => `
    margin: ${theme.padding[1]};
`}`;

export function SVGInfo({ children }: PropsWithChildren) {
  const theme = useStyledTheme();

  return (
    <Info
      icon={<IconContainer><InformationIcon fill={theme.colours.info[1]} /></IconContainer>}
    >
      <InfoItemContainer>
        {children}
      </InfoItemContainer>
    </Info>
  );
}
